import {RowSection, SkeletonBlock} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const CouponLandingPageCategorySliderLoading: React.FC<{
  className?: string;
}> = ({className}) => {
  return (
    <Container className={className}>
      <StyledSkeletonBlock />
      <StyledSkeletonBlock />
      <StyledSkeletonBlock />
      <StyledSkeletonBlock />
    </Container>
  );
};

const Container = styled(RowSection)`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  width: 100%;
  height: 50px;
  padding: 0.5rem 1rem;
`;

const StyledSkeletonBlock = styled(SkeletonBlock)`
  width: 100%;
  height: 100%;
`;
